/**
 * Mutation hook for PATCH /api/auth/profile.
 *
 * Updates the user's preferred_name and invalidates the auth cache
 * so the dashboard greeting reflects the change immediately.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import { AUTH_QUERY_KEY, type User } from "@/features/auth/useAuth";

interface UpdateProfileInput {
  preferred_name: string | null;
}

export function useUpdateProfile() {
  const queryClient = useQueryClient();
  return useMutation<User, Error, UpdateProfileInput>({
    mutationFn: (input) =>
      apiFetch<User>("/api/auth/profile", {
        method: "PATCH",
        body: input,
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: AUTH_QUERY_KEY });
    },
  });
}
